import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';

import BackendService from '../services/backendService';
import { UserTenant } from '../services/CoreAPIService/CoreAPIService';

function useTenants(_?: boolean) {
  const tenantsCache = 'tenants';
  const router = useRouter();

  const tenantIdByUrl: string | undefined = router.query.tenantId as string | undefined;
  const [hasAccessToTenantByUrl, setHasAccessToTenantByUrl] = useState(true);
  const { data, isFetching, error } = useQuery<{ user: UserTenant }>({
    queryKey: [tenantsCache, tenantIdByUrl],
    queryFn: () => BackendService.instance.retrieveCurrentTenants(),
    staleTime: 5000 * 60 * 5,
  });

  useEffect(() => {
    if (data) {
      const hasAccess = data.user.availableTenants.find(
        (t: { tenantId: string }) =>
          t.tenantId === tenantIdByUrl || t.tenantId === data?.user.activeTenantId,
      );
      setHasAccessToTenantByUrl(!!hasAccess);
    } else if (!isFetching) {
      setHasAccessToTenantByUrl(false);
    }
  }, [data, isFetching, tenantIdByUrl]);

  const filteredTenants = useMemo(() => {
    if (data) {
      return {
        ...data,
        user: {
          ...data.user,
          availableTenants: data.user.availableTenants,
        },
      };
    }
  }, [data]);

  return {
    data,
    filteredTenants,
    error,
    isLoading: isFetching,
    hasAccessToTenantByUrl,
  };
}

export default useTenants;
